export const enquirystyle={
    main:{
        flexDirection:'column',p:2,backgroundColor:'#F1F5FB'
    }
}